import PolicyPage from "@/components/site/PolicyPage";

export default function PrivacyPolicy() {
  return <PolicyPage slug="privacy" fallbackTitle="Privacy policy" testId="page-privacy-policy" />;
}
